<app-so-content [isActive]="dateActive">
  <div class="date flex-it col">
    <h1>Select a nomination date and horizon</h1>
    <!-- date picker -->
    <mat-calendar [selected]="curDate"
                  [dateFilter]="daFilter"
                  (selectedChange)="onChangeDate($event)">
    </mat-calendar>
    <!-- horizon up to D+n -->
    <mat-form-field floatLabel="always">
      <mat-select [placeholder]="'show data from D+' + horAsOf + ' to...'"
                  required
                  [(ngModel)]="horUpTo"
                  (ngModelChange)="onChangeHor()">
        <mat-option *ngFor="let day of horDays" [value]="day">
          {{'D+' + day}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</app-so-content>
